import {ActiveUserService, CEProtocol, CEConstructor, ListSpecType} from 'lionheartland';
import {HttpClient} from 'lionheartland';
import {EORolePermissionService} from '../../core/role-permission/eo-role-permission';
import {SOGetRolePermission} from '../../core/role-permission/so-get-role-permission';
import {RAPutRolePermission} from './ra-put-role-permission';
import {RAPostRolePermission} from './ra-post-role-permission';
import {RADeleteRolePermission} from './ra-delete-role-permission';
import {AbstractEntityCore} from 'lionheartland';
import {EntityCoreProtocol} from 'lionheartland';
import {SOGetOrganization} from '../../core/organization/so-get-organization'
import { CERolePermission } from "./ce-role-permission"


export class RolePermissionCoreBase extends AbstractEntityCore implements EntityCoreProtocol {

  type = 'rolePermission';
  title = 'Role permission';
  ceProtocol: CEConstructor = CERolePermission

  entityService: EORolePermissionService;
  soGetClass = SOGetRolePermission;
  soGet: SOGetRolePermission;


  constructor(
    public activeUserService: ActiveUserService,
  ) {
    super(
      activeUserService,
      EORolePermissionService,
      null,
    );
    this.adapters = [
      new RAPostRolePermission(this),
      new RAPutRolePermission(this),
      new RADeleteRolePermission(this),
    ];
    this.resetSoGet()
    this.setDefaultAdapters();
    this.finalInit();
  }

  resetSoGet() {
    this.soGet = new SOGetRolePermission();
    if (this.activeUserService.getScope('organization')) {
        this.soGet.organization = new SOGetOrganization(
          this.activeUserService.getScope('organization').uid
        );
    }
    this.soGet.queryOptions.limit = this.limit;
    this.soGet.queryOptions.sortKey = 'dateCreated';
    this.soGet.queryOptions.descending = true;
  }


}